import { useEffect } from "react";
import { useAuthStore } from "../contexts/AuthContext";
import { useRoleDispatch } from "../contexts/RoleContext";

export default function useGetRoles() {
  const roleDispatch = useRoleDispatch();
  const { selectedAccount } = useAuthStore();

  useEffect(() => {
    roleDispatch({ type: "setIsLoadingRoles", payload: true });

    let url = "/api/roles";

    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        roleDispatch({ type: "setRoles", payload: data });
        roleDispatch({ type: "setIsLoadingRoles", payload: false });
      });
  }, [selectedAccount, roleDispatch]);
}
